import VerifyTradeHistory from "./VerifyTradeHistory";
import "./VerifiedPaymentBillingHistory.css";
import { useEffect, useState } from "react";
import VerifiedPaymentSubscriptionPlan from "./VerifiedPaymentSubscriptionPlan/index.jsx";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import StripePaymentModal from "../../sharedPages/StripePaymentModal/index.jsx";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useApi from "../../../helpers/apiHelper/requestHelper.js";
import { useDispatch, useSelector } from "react-redux";
import { storeUser } from "../../../redux/users/usersSlice.js";
import { showNotificationToast, toastify } from "../../../helpers/toast/toastify.js";
import StoringOnSolanaPlatform from "../../sharedPages/StoringOnSolanaPlatform/index.jsx";
import SubscribedInfoModal from "../../sharedPages/SubscribedInfoModal/index.jsx";
import PaymentSuccessModal from "../../sharedPages/PaymentSuccessModal/index.jsx";
import LoadingOverlayModal from "../../sharedPages/LoadingOverlayModal/index.jsx";

const VerifiedPaymentBillingHistory = () => {
  const [clientSecret, setClientSecret] = useState("");
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [subscribed, setSubscribed] = useState();
  const [displaySolanaModal, setDisplaySolanaModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const user = useSelector((state) => state?.user?.user);
  const sessionId = searchParams.get("session_id");
  const [displaySubscribedModal, setdisplaySubscribedModal] = useState(false);
  const api = useApi();
  const [activeButton, setActiveButton] = useState(
    user?.verifiedmyTrade?.subscription?.planType === "year" &&
      user?.verifiedmyTrade?.subscription?.status === "active"
      ? "Yearly"
      : "Monthly"
  );
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const sendUserDataOnBlockChain = async () => {
    try {
      const response = await api("post", "blocakChain/sendSpecificUserStatsOnBlockChain");
      // console.log("Successfully sent to blockchain API", response);
     
      setSubscribed(true);
      // console.log("after_blockchain_success", response);
      // wait 1.5s
      await delay(1500);
      setSubscribed(false);
      if(!response.status){
        throw new Error(response.message);
      }
      setDisplaySolanaModal(true);

      // wait another 3s
      await delay(3000);
      setDisplaySolanaModal(false);
      setPaymentLoading(false);
      setdisplaySubscribedModal(true);
      navigate(location.pathname, { replace: true });
      
      // If you want to navigate after showing subscribed modal
      // navigate("/leader/verifymyTrade/subscribedInfoModal");
    } catch (error) {
      console.log("Error sending to blockchain:", error);
      throw error;
    }
  };

  async function getUser() {
    try {
      const response = await api("get", "users/index");
      if (response?.status) {
        const { data } = response;
        if (dispatch && storeUser) dispatch(storeUser(data));
        setActiveButton(
          data?.user?.verifiedmyTrade?.subscription?.planType === "year" &&
            data?.user?.verifiedmyTrade?.subscription?.status === "active"
            ? "Yearly"
            : "Monthly"
        );
        if (data?.token) localStorage.setItem("token", data.token);
      }
    } catch (err) {
      console.log(err.message);
    }
  }
  //subscription
  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        setPaymentLoading(true);
        setLoading(true);
        const response = await api(
          "get",
          `users/verifyTradeCheckoutSubscription?session_id=${sessionId}`
        );

        if (response?.status && response.data.paid) {
          await sendUserDataOnBlockChain();
          await getUser();
          // showNotificationToast("Verifying your trades now!", "Your trading is now being verified.You'll get a link each time it's updated on-chain.\n\nUpgrade your subscription for more frequent updates.");
          navigate(location.pathname);  
          // dispatch(setRefetchSpecificUser(true));
          setLoading(false);
          // setPaymentLoading(false);
        } else {
          setLoading(false);
          // setPaymentLoading(false);
          toastify("Payment not completed or failed.");
        }
      } catch (error) {
        setLoading(false);
        setPaymentLoading(false);
        toastify("Error while storing performance on blockchain");
        navigate(location.pathname, { replace: true });
        console.error("Payment check failed:", error);
        toastify("Something went wrong");
      }
    };

    if (sessionId) checkPaymentStatus();
  }, [sessionId]);

  return (
    <>
      {!paymentLoading && !sessionId ? (
        <div className={`subscriptionBillingHistoryWrapper`}>
          {clientSecret ? (
            <StripePaymentModal
              setClientSecret={setClientSecret}
              clientSecret={clientSecret}
            />
          ) : (
            <>
              <VerifiedPaymentSubscriptionPlan
                setPaymentLoading={setPaymentLoading}
                paymentLoading={paymentLoading}
                setClientSecret={setClientSecret}
                activeButton={activeButton}
                setActiveButton={setActiveButton}
              />
              <VerifyTradeHistory />
            </>
          )}
        </div>
      ) : (
        // <LoadingOverlay />
        <LoadingOverlayModal />
      )}
      {subscribed && <PaymentSuccessModal />}
      {displaySubscribedModal && (
        <SubscribedInfoModal
          setdisplaySubscribedModal={setdisplaySubscribedModal}
        />
      )}
      {displaySolanaModal && <StoringOnSolanaPlatform />}
    </>
  );
};

export default VerifiedPaymentBillingHistory;
